import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaComments,
  FaGraduationCap,
  FaPenNib,
  FaGlobe,
  FaBuilding,
  FaUsers,
} from "react-icons/fa";
import "./DirectorsMessage.css";

const DirectorsMessage = () => {
  return (
    <section className="directors_message_section">
      <Container>
        <div className="directors_message_wrapper">
          <Row className="g-0 align-items-stretch">

            {/* LEFT SIDE */}
            <Col lg={3} md={12}>
              <div className="director_profile_card">

                <div className="director_profile_shape"></div>

                <div className="director_image_box">
                  <img
                    src="/assets/images/pst_it_solution/director/Praful-sir.png"
                    alt="Director"
                    className="director_img"
                  />
                </div>

                <div className="director_profile_content">
                  <h3 className="director_name">
                    Dr. Praful S. Tayde
                  </h3>

                  <p className="director_qualification">
                    PhD, MTech, B.E-CSE
                  </p>

                  <div className="director_line"></div>

                  <h5 className="director_designation">
                    Managing Director
                  </h5>

                  <p className="director_company">
                    PST IT Solutions
                  </p>
                </div>
              </div>
            </Col>

            {/* RIGHT SIDE */}
            <Col lg={9} md={12}>
              <div className="director_message_content">

                {/* TITLE */}
                <div className="director_title_box">
                  <div className="director_title_icon">
                    <FaComments />
                  </div>

                  <div>
                    <h2 className="director_title">
                      About Director
                    </h2>
                    <div className="director_title_line"></div>

                    <h4 className="director_point_heading">
                        Empowering Through Continuous Learning
                      </h4>
                  </div>
                </div>

                {/* MESSAGE LIST */}
                <div className="director_message_points">

                  <div className="director_point">
                    <div className="director_point_icon">
                      <FaGraduationCap />
                    </div>

                    <div className="director_point_content">
                      

                      <p className="director_desc">
                        At PST IT Solutions, the belief that continuous learning
                        is the foundation of innovation and long-term success
                        drives every initiative. This vision is centered on
                        empowering individuals and organizations through
                        advanced technology and quality education.
                      </p>
                    </div>
                  </div>

                  <div className="director_point">
                    <div className="director_point_icon">
                      <FaPenNib />
                    </div>

                    <div className="director_point_content">
                      <p className="director_desc">
                        Dr. Praful S. Tayde is a visionary leader with over
                        15 years of experience in the IT industry and education
                        sectors. As the Principal of a reputed engineering
                        institution in Chhatrapati Sambhaji Nagar, Maharashtra,
                        he has consistently worked toward transforming education
                        through innovation, research, and industry-oriented
                        learning.
                      </p>
                    </div>
                  </div>

                  <div className="director_point">
                    <div className="director_point_icon">
                      <FaGlobe />
                    </div>

                    <div className="director_point_content">
                      <p className="director_desc">
                        He holds <strong>seven patents</strong> in emerging
                        technology domains, reflecting his strong commitment to
                        innovation and practical problem solving. He is also the
                        <strong>
                          {" "}
                          author of the renowned book, “Cloud AI Engineering:
                          A Practitioner’s Guide,”
                        </strong>{" "}
                        which effectively bridges the gap between academic
                        knowledge and real-world applications. Furthermore, he
                        has made significant contributions to the research
                        community with multiple publications in
                        <strong>
                          {" "}
                          Springer, Scopus-indexed journals, and reputed
                          international journals and conferences.
                        </strong>
                      </p>
                    </div>
                  </div>

                  <div className="director_point">
                    <div className="director_point_icon">
                      <FaBuilding />
                    </div>

                    <div className="director_point_content">
                      <p className="director_desc">
                        One of his key initiatives, the
                        <strong> Big Data Institute</strong>, was established to
                        create valuable opportunities for aspiring
                        professionals. This initiative equips learners with
                        advanced skills in Big Data, Artificial Intelligence,
                        and modern cloud technologies, enabling them to excel in
                        today’s competitive landscape.
                      </p>
                    </div>
                  </div>

                  <div className="director_point">
                    <div className="director_point_icon">
                      <FaUsers />
                    </div>

                    <div className="director_point_content">
                      <p className="director_desc">
                        At PST IT Solutions, the focus is not only on education
                        but also on inspiring innovation, critical thinking,
                        and leadership. The mission is to build a future-ready
                        workforce capable of driving technological advancement
                        and societal progress.
                      </p>

                      <p className="director_desc mb-0">
                        Dr. Praful Tayde invites you to be part of this journey
                        of learning, innovation and career transformation —
                        where knowledge meets creativity and opportunities
                        become limitless.
                      </p>
                    </div>
                  </div>

                </div>

              </div>
            </Col>

          </Row>
        </div>
      </Container>
    </section>
  );
};

export default DirectorsMessage;